import {
  Collapse,
  ColorPicker,
  Form,
  InputNumber,
  Select,
  Space,
  Switch,
} from "antd";
import React from "react";
import { Color } from "antd/es/color-picker";

interface AppearanceProps {
  name: (string | number)[];
}

export const Appearance = (props: AppearanceProps) => {
  return (
    <Collapse size="small">
      <Collapse.Panel key={"appearance"} header={`Appearance`}>
        <Space direction="horizontal" size="middle" align="baseline">
          <Form.Item label="Opacity" name={[...props.name, "opacity"]}>
            <InputNumber min={0} max={1} step={0.01} />
          </Form.Item>
          <Form.Item label="Visible" name={[...props.name, "visible"]}>
            <Switch />
          </Form.Item>
          <Form.Item
            label="User Interactable"
            name={[...props.name, "clickable"]}
          >
            <Switch />
          </Form.Item>
        </Space>

        <Space direction="horizontal" size="middle">
          <Form.Item label="Font" name={[...props.name, "font_style"]}>
            <Select
              style={{ minWidth: "150px" }}
              options={[
                { label: "Normal", value: "normal" },
                { label: "Bold", value: "bold" },
                { label: "Italic", value: "italic" },
                { label: "Bold Italic", value: "bold_italic" },
              ]}
            />
          </Form.Item>
          <Form.Item label="Outlined" name={[...props.name, "outlined"]}>
            <Switch />
          </Form.Item>
        </Space>

        <Space direction="horizontal" size="middle">
          <Form.Item
            label="Stroke Width"
            name={[...props.name, "stroke_width"]}
          >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item
            label="Stroke Color"
            normalize={(value: Color) => `#${value.toHex()}`}
            name={[...props.name, "stroke_color"]}
          >
            <ColorPicker showText format="hex" />{" "}
          </Form.Item>
          <Form.Item
            label="Shadow Color"
            normalize={(value: Color) => `#${value.toHex()}`}
            name={[...props.name, "shadow_color"]}
          >
            <ColorPicker showText format="hex" />{" "}
          </Form.Item>
          <Form.Item
            label="Background Color"
            normalize={(value: Color) => `#${value.toHex()}`}
            name={[...props.name, "background_color"]}
          >
            <ColorPicker showText format="hex" />{" "}
          </Form.Item>
        </Space>
      </Collapse.Panel>
    </Collapse>
  );
};
